import React from "react";
import ModuleShowcasePage from "../../marketing/ModuleShowcasePage";

const AsapPilot = () => <ModuleShowcasePage moduleKey="pilot" />;

export default AsapPilot;
